export enum ELASTIC_SEARCH_TYPE {
  ORGANIZATION = 'organization',
  USER = 'user',
  MACHINERY_GROUP = 'machineryGroup',
  MACHINE = 'machine',
  GATEWAY = 'gateway',
  BASE_MENU_ITEM = 'baseMenuItem',
  USER_MENU_ITEM = 'userMenuItem',
  GATEWAY_META_DATA = 'gatewayMetadata',
  MACHINE_META_DATA = 'machineMetadata',
}